var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('v-chip',{attrs:{"small":"","color":_vm.color,"dark":""}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }